import { useState } from "react";
import { tokens } from "../../theme/theme";
import { Typography, Card, CardContent, Grid, useTheme, Box, } from "@mui/material";


// icons 
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CategoryIcon from '@mui/icons-material/Category';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EngineeringIcon from '@mui/icons-material/Engineering';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RecyclingIcon from '@mui/icons-material/Recycling';
import LocationOnIcon from '@mui/icons-material/LocationOn';


import { useTranslation } from "react-i18next";
import DashboardCard from "../../components/common/DashboardCard";

const MasterMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();
    const [xlValue, setXLValue] = useState(2);

    const callback = () => {
        handleBackDashboard();
    };

    return (
        <Box >
            <Card sx={{ backgroundColor: "transparent" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h4" color={colors.grey[100]} fontWeight="bold" justifyContent="center">Masters </Typography>
                    </Box>
                </CardContent>
            </Card>

            {/* <Divider /> */}
            <Box p={2}>
                <Grid container spacing={2} justifyContent="start" marginTop="10px"  >
                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('master.party_master')}
                            icon={<AccountCircleIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("PartyMaster")}
                            subtitle="View"
                        />
                    </Grid>



                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('master.product_master')}
                            icon={<CategoryIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("ProductMaster")}
                            subtitle="View"
                        />
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('master.machine_master')}
                            icon={<PrecisionManufacturingIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("MachineMaster")}
                            subtitle="View"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('master.remarks_master')}
                            icon={<NotificationsIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("RemarksMaster")}
                            subtitle="View"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('master.bank_master')}
                            icon={<AccountBalanceIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("BankMaster")}
                            subtitle="View"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('master.overtime_master')}
                            icon={<AccessTimeIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("OverTimeMaster")}
                            subtitle="View"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('master.operator')}
                            icon={<EngineeringIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("Operator")}
                            subtitle="View"
                        />
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('master.qc_property_master')}
                            icon={<CheckCircleOutlineIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("QCProperty")}
                            subtitle="View"
                        />
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('master.repulp_waster_type')}
                            icon={<RecyclingIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("QCProperty")}
                            subtitle="View"
                        />
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} lg={3} xl={xlValue}>
                        <DashboardCard
                            title={t('master.repulp_waste_location')}
                            icon={<LocationOnIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("RepulpWasteLocationMaster")}
                            subtitle="View"
                        />
                    </Grid>

                </Grid>
            </Box>
        </Box>

    )
}
export default MasterMenu;